export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";